export function checklistItems(bloks, variant = 'included') {
    if (!Array.isArray(bloks))
        return []

    return bloks
        .filter(item => item?.component === 'checklist-item' && item.variant === variant)
        .map(item => String(item.text || '').trim())
        .filter(Boolean)
}
